import React, { useEffect, useRef } from "react";
import { useFrame, useThree } from "@react-three/fiber";
import { useSceneNodes } from "./SecondaryScene";
import * as THREE from "three";
import useFlowStore from "../store/flowStore";
import CameraManager from "../manager/CameraManager";
import useHoverRaycast from "../../hooks/useHoverRaycast";
import useCursorStore from "../store/cursorStore";
import { audios } from "../../assets/assets";

export default function RoomScene({ light, interactUIRef }) {
  const { room } = useSceneNodes();
  const telescopeHitboxRef = useRef();
  const { flowSteps, nextStep, currentStep, playCurrentAudio } =
    useFlowStore.getState();
  const { setCursorScale, setCursorInteractive } = useCursorStore.getState();

  useHoverRaycast();

  useEffect(() => {
    if (!room) return;
    const { currentStep, flowSteps, nextStep } = useFlowStore.getState();
    const step = flowSteps[currentStep];

    if (step?.label === "Telescope") {
      // Play Telescope audio
      playCurrentAudio(() => {
        const telescopeHitbox = room.getObjectByName("telescope_hitbox");
        telescopeHitbox.userData.isClickable = true;
        setCursorInteractive(true);
        useFlowStore.getState().setShowInteractUI(true);
      });
    }
  }, [room, currentStep]);

  useEffect(() => {
    if (!room) return;

    const planToHide = room.getObjectByName("mursinvisibles");
    if (planToHide) planToHide.visible = false;

    // const telescope = room.getObjectByName("telescope");
    // if (telescope) {
    //   telescope.traverse((child) => {
    //     if (child.isMesh) {
    //       child.layers.enable(10);
    //       child.material = child.material.clone();
    //     }
    //   });
    // }

    const telescopeHitbox = room.getObjectByName("telescope_hitbox");

    if (telescopeHitbox) {
      telescopeHitbox.visible = false;
      telescopeHitbox.frustumCulled = false;
      telescopeHitbox.material = new THREE.MeshBasicMaterial({
        transparent: true,
        opacity: 0,
        depthWrite: false,
      });
      telescopeHitbox.raycast = THREE.Mesh.prototype.raycast;
      telescopeHitbox.userData.isClickable = false;
      telescopeHitbox.userData.onPointerOver = () => setCursorScale(3.5);
      telescopeHitbox.userData.onPointerOut = () => setCursorScale(1);

      // PERMIT TO CLICK ONLY ONCE
      let hasClicked = false;

      telescopeHitbox.userData.onClick = async () => {
        // PERMIT TO CLICK ONLY ONCE
        if (hasClicked) return;
        hasClicked = true;

        // HIDE INTERACT UI
        if (interactUIRef?.current) {
          await interactUIRef.current.exit();
        }

        CameraManager.resetLookTargetWithAnimation({
          duration: 1,
          onComplete: () => {
            const swooshAudio = new Audio(audios.swoosh_telescope_in);
            swooshAudio.play().catch(console.warn);

            telescopeHitbox.userData.isClickable = false;
            telescopeHitbox.userData.onPointerOver = null;
            telescopeHitbox.userData.onPointerOut = null;

            setTimeout(() => {
              setCursorScale(1);
              setCursorInteractive(false);
            }, 100);

            CameraManager.playAnimation(() => {
              nextStep(() => {
                console.log("Scène Room terminée ! Going to MoonUI Scene");
                setTimeout(() => {
                  CameraManager.switchCamera("camera_3");
                }, 2000);
                // CameraManager.reset();
              });
            }, 3000);
          },
        });
      };
    }
  }, [room]);

  const handleClick = (e) => {
    e.stopPropagation();
    const clicked = e.object;
    if (clicked.userData.isClickable && clicked.userData.onClick) {
      clicked.userData.onClick();
    }
  };

  if (!room) return null;

  return <primitive object={room} onPointerDown={handleClick} />;
}
